import React, { useState } from "react";
import { Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import "../../molecules/BrandModal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faTimes } from "@fortawesome/free-solid-svg-icons";

export const SendToMDMModal = ({ toggle, setToggle, onSubmit, accountId, requireShortname }) => {
  const [shortname, setShortname] = useState("");
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const close = () => {
    setToggle(false);
    setShortname("");
    setShowError(false);
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (requireShortname) {
      if (!shortname.trim()) {
        setError("Required");
        setShowError(true);
        return;
      }
      if (shortname.trim().length > 30) {
        setError("Short name must not exceed 30 characters.");
        setShowError(true);
        return;
      }
    }
    setSubmitting(true);
    try {
      const result = await onSubmit(accountId, requireShortname ? shortname : undefined);
      if (result !== null) {
        setError(result);
        setShowError(true);
        return;
      }
      close();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen={toggle} toggle={close} className="brand-modal">
      <ModalHeader toggle={close}>Send to MDM</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">Are you sure you want to send this account to MDM?</p>
        <Form onSubmit={handleSubmit}>
          {requireShortname && (
            <FormGroup>
              <Label for="shortnameId">Short name</Label>
              <Input
                type="text"
                name="shortnameId"
                id="shortnameId"
                placeholder="Short name"
                onChange={(e) => {
                  setShortname(e.target.value);
                  if (e.target.value.trim()) setShowError(false);
                }}
                value={shortname}
              />
              {showError && <p className="text-danger">{error}</p>}
            </FormGroup>
          )}
          <div className="brand-modal__actions">
            <button type="submit" className="brand-modal__btn brand-modal__btn--primary" disabled={submitting}>
              <FontAwesomeIcon icon={faUpload} /> {submitting ? "Sending…" : "Send to MDM"}
            </button>
            <button type="button" className="brand-modal__btn brand-modal__btn--cancel" onClick={close} disabled={submitting}>
              <FontAwesomeIcon icon={faTimes} /> Cancel
            </button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};
